import dayjs from "dayjs";

export function endOfTheDay(date: Date | string | undefined): Date | undefined {
    if (date === undefined  || date === "") {
        return undefined;
    } else {
        return dayjs(date).endOf("day").toDate();
    }
}

export function startOfTheDay(date: Date | string | undefined): Date | undefined {
    if (date === undefined  || date === "") {
        return undefined;
    } else {
        return dayjs(date).startOf("day").toDate();
    }
}